// Third-party Imports
import { toast } from 'sonner'

// Type Imports
import type { NotificationProvider } from '@refinedev/core'

/** Bridges Refine's mutation notifications onto the template's sonner toaster. */
export const notificationProvider: NotificationProvider = {
  open: ({ key, message, description, type, undoableTimeout, cancelMutation }) => {
    if (type === 'progress') {
      toast.loading(message, {
        id: key,
        description,
        duration: (undoableTimeout ?? 5) * 1000,
        action: cancelMutation ? { label: 'Буцаах', onClick: cancelMutation } : undefined
      })

      return
    }

    const notify = type === 'success' ? toast.success : toast.error

    notify(message, { id: key, description })
  },
  close: key => toast.dismiss(key)
}
